import React, { Component } from "react";
import * as Sentry from "@sentry/browser";
import "./ErrorBoundary.scss";
import NavbarContainer from "../Navbar/NavbarContainer";
import { withRouter } from "react-router-dom";
import { isProduction } from "../../lib/utils";

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        const token = localStorage.getItem("token");
        const company_identifier = JSON.parse(localStorage.getItem("meta"))?.company?.company_identifier;
        this.state = { hasError: false, token, company_identifier };
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        return { hasError: true };
    }

    componentDidCatch(error, info) {
        // You can also log the error to an error reporting service
        console.log("error", error);
        console.log("info", info);
        // if (window.location.href.indexOf("commandcenter") > -1)
        if (isProduction()) {
            Sentry.withScope((scope) => {
                scope.setExtras(info);
                scope.setExtras({ userToken: this.state.token });
                scope.setExtras({ company: this.state.company_identifier });
                const eventId = Sentry.captureException(error);
                this.setState({ eventId });
            });
        }
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div className="errorBoundary skiptranslate">
                    <NavbarContainer history={this.props.history} location={this.props.location} />
                    <h1>Oops. Something went wrong. Please re-load the page.</h1>
                </div>
            );
        }

        return this.props.children;
    }
}

export default withRouter(ErrorBoundary);
